import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const GroupItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;

  .label {
    font-size: 0.75rem;
    color: #6b6b6b;
    font-weight: 500;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    margin-bottom: 6px;
    display: block;
  }
`;

export const BtnGroupContainer = styled.div`
  display: flex;
  align-items: center;
  z-index: 0;
  color: #706f6f;
  font-family: 'Jost', sans-serif !important;
  font-weight: 500;
  font-size: 16px;
  .btn-group {
    cursor: pointer;
    border-radius: 0px;
    background-color: #ecedf0;
    color: rgb(37, 56, 88);
    border: none;
    font-size: 0.9rem;
    &:active {
      outline: none;
      box-shadow: none !important;
    }
    &:focus {
      outline: none;
      box-shadow: none !important;
    }
    &:hover {
      background-color: #8850bf;
      color: #fff !important;
    }
  }

  .btn-group-active {
    background-color: #57069e;
    color: #fff !important;

    &:hover {
      background-color: #57069e;
      color: #fff;
    }
  }
`;

export const ContainerGrid = styled.div`
  margin-top: 1.5rem;
  .DataGrid {
    .Mui-selected {
      background-color: #acfcbf !important;
    }
    .MuiDataGrid-selectedRowCount {
      opacity: 0;
    }
    .MuiDataGrid-columnHeaderWrapper {
      background-color: #8850bf;
    }
    .MuiDataGrid-renderingZone:before {
      background-color: red;
    }

    .hideRightSeparator .MuiDataGrid-columnSeparator {
      display: none;
    }
  }
`;
